module.exports = __webpack_public_path__ + "assets/c7f2e37e83b47ab07484654989aa8861.png";